import { downloadFile } from "@/core/utils";
import { getErrorMessage, isAPIError } from "@/core/services";
import { buildCsvFile } from "./csv-file";
import { buildPdfFile } from "./pdf-file";
import { buildXlsxFile } from "./xlsx-file";
import { findExportFormatDetail } from "./export.types";
import type { ExportFormat, ExportTableViewParams, TableView } from "./export.types";

export const EXPORT_SUCCESS_SUMMARY = "Exportação concluída";
export const EXPORT_SUCCESS_MESSAGE = "O arquivo da visualização foi gerado com sucesso.";
export const EXPORT_ERROR_MESSAGE = "Não foi possível exportar a visualização.";
export const EXPORT_FORBIDDEN_SUMMARY = "Acesso não autorizado";
export const EXPORT_FORBIDDEN_MESSAGE = "Você não tem permissão para exportar esta listagem.";
export const EXPORT_EMPTY_SUMMARY = "Nada a exportar";
export const EXPORT_EMPTY_MESSAGE = "Não há registros na visualização atual.";

const FILE_BUILDERS: Record<ExportFormat, (view: TableView) => Uint8Array> = {
  pdf: buildPdfFile,
  xlsx: buildXlsxFile,
  csv: buildCsvFile,
};

const FILE_NAME_DATE_FORMATTER = new Intl.DateTimeFormat("pt-BR", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

function toFileNameDate(date: Date): string {
  return FILE_NAME_DATE_FORMATTER.format(date).split("/").reverse().join("-");
}

export function buildExportFileName(
  fileName: string,
  format: ExportFormat,
  date = new Date(),
): string {
  return `${fileName}-${toFileNameDate(date)}.${findExportFormatDetail(format).extension}`;
}

/** Gera e entrega um único arquivo com a visualização atual (AC3). */
export function exportTableView({ format, view }: ExportTableViewParams): string {
  const detail = findExportFormatDetail(format);
  const fileName = buildExportFileName(view.fileName, format);

  downloadFile(FILE_BUILDERS[format](view), fileName, detail.mimeType);

  return fileName;
}

/** RN005 — a recusa do serviço por falta de autorização tem mensagem própria. */
export function resolveExportError(error: unknown): { summary: string; detail: string } {
  if (isAPIError(error) && error.status === 403) {
    return { summary: EXPORT_FORBIDDEN_SUMMARY, detail: EXPORT_FORBIDDEN_MESSAGE };
  }

  return { summary: EXPORT_ERROR_MESSAGE, detail: getErrorMessage(error) };
}
